import { render } from "./ModalBookshelfItemAdd.vue?vue&type=template&id=cea6545e&scoped=true"
import script from "./ModalBookshelfItemAdd.vue?vue&type=script&lang=js"
export * from "./ModalBookshelfItemAdd.vue?vue&type=script&lang=js"

import "./ModalBookshelfItemAdd.vue?vue&type=style&index=0&id=cea6545e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea6545e"]])

export default __exports__